module.exports = __webpack_public_path__ + "img/angle-down.b080e448.svg";